<script>
import appConfig from '@src/app.config'
import { PaladinCoreUIStateHelpers } from '@paladin/core-ui'
// import store from '@state/store'

export default {
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  computed: {
    ...PaladinCoreUIStateHelpers.layoutComputed,
  },
}
</script>

<template>
  <div :class="{ app: true, 'nav-open': showSidebar, loading: isLoading }">
    <BaseLoader />
    <Notifications
      transition-name="notification-list"
      transition-mode="out-in"
    />
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <RouterView />
  </div>
</template>

<!-- This should generally be the only global CSS in the app. -->
<style lang="scss">
// Allow element/type selectors, because this is global CSS.
// stylelint-disable selector-max-type, selector-class-pattern

// Normalize default styles across browsers,
// https://necolas.github.io/normalize.css/
@import '~normalize.css/normalize.css';
// Style loading bar between pages.
// https://github.com/rstacruz/nprogress
// @import '~nprogress/nprogress.css';

// Import notifyjs
@import '~vue-notifyjs/themes/material.css';

// Bootstrap styles
@import '~bootstrap/dist/css/bootstrap.css';
@import '~bootstrap-vue/dist/bootstrap-vue.css';

// Design variables and utilities from src/design.
@import '@design';

.vue-notifyjs.notifications {
  .alert {
    z-index: 10000;
  }
  .list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .list-enter-active {
    transition: transform 0.2s ease-in, opacity 0.4s ease-in;
  }
  .list-leave-active {
    transition: transform 1s ease-out, opacity 0.4s ease-out;
  }
  .list-enter {
    opacity: 0;
    transform: scale(1.1);
  }
  .list-leave-to {
    opacity: 0;
    transform: scale(1.2, 0.7);
  }
}

// #nprogress .bar {
//   background: $color-link-text;
// }
</style>
